import { render, staticRenderFns } from "./MdtFileDownload.vue?vue&type=template&id=b63e9250&scoped=true"
import script from "./MdtFileDownload.vue?vue&type=script&lang=js"
export * from "./MdtFileDownload.vue?vue&type=script&lang=js"
import style0 from "./MdtFileDownload.vue?vue&type=style&index=0&id=b63e9250&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63e9250",
  null
  
)

export default component.exports